const hostname = window && window.location && window.location.hostname;

let config2use = "";
let blob2use = "";

if (hostname === "localhost"){  
    config2use = process.env.REACT_APP_DEVENV;
    blob2use = process.env.REACT_APP_UAT;
} else if (hostname === "uatenterprise.lockviewer.com"){
    config2use = process.env.REACT_APP_UATENV;
    blob2use = process.env.REACT_APP_UAT;
} else {
    config2use = process.env.REACT_APP_PRODENV;
    blob2use = process.env.REACT_APP_PROD;
}

export const serverAddr = {    
    apiUrl: config2use,
    blobContainer: blob2use
};
